module.exports = __webpack_public_path__ + "img/jacket-front-sub-setIn-classic.8f2deeb2.png";